module.exports = __webpack_public_path__ + "static/media/screenshot-7.756657a3.png";